import { render, staticRenderFns } from "./TransferenciaEntreAlmacenes.vue?vue&type=template&id=dbe29aa8&scoped=true&"
import script from "./TransferenciaEntreAlmacenes.vue?vue&type=script&lang=js&"
export * from "./TransferenciaEntreAlmacenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe29aa8",
  null
  
)

export default component.exports